import { useState, useEffect } from 'react';
import React, { useParams } from 'react-router-dom';
import axios from 'axios';

const EnableMusic = () => {
  const { id } = useParams();
  const [isMusicEnabled, setIsMusicEnabled] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
        .then(response => {
          console.log(response.data.music);
          const musicStatus = JSON.parse(response.data.music);
          setIsMusicEnabled(musicStatus);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
  }, []);

  const toggleMusic = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-music/${id}`, { music: !isMusicEnabled })
      .then(response => {
          console.log(response.data.message); // Log success message
          setIsMusicEnabled(!isMusicEnabled);
          window.location.reload();
      })
      .catch(error => {
          console.error('Error updating music:', error);
      });
  };

  return (
    <div className="flex items-center">
      <h1 className='text-secondary-500 font-bold'>Aktifkan lagu?</h1>
      <input
        type="checkbox"
        checked={isMusicEnabled}
        onChange={toggleMusic}
        id="musicToggle"
        className="hidden"
      />
      <label
        htmlFor="musicToggle"
        className="flex items-center cursor-pointer bg-gray-100 w-14 h-7 rounded-full p-1 border border-gray-300 transition duration-300 ease-in-out ml-auto"
      >
        <div
          className={`${
            isMusicEnabled ? 'translate-x-7 bg-green-500' : 'translate-x-0 bg-gray-400'
          } w-5 h-5 rounded-full shadow-md transform transition-transform`}
        ></div>
      </label>
    </div>

  );
};

export default EnableMusic;
